import { AccessibilityStoreState } from '@core/data-access/models/accessibility/accessibility-store.model';
import { AccessibilityFontSizePercentage } from '@core/data-access/models/accessibility/accessibility.model';
import { createReducer, on } from '@ngrx/store';
import { AccessibilityActions } from './accessibility.actions';

export const accessibilityReducerKey = 'accessibility';

const initialAccessibilityStoreState: AccessibilityStoreState = {
  isHighContrastEnabled: false,
  fontSizePercentage: AccessibilityFontSizePercentage.Default
};

export const accessibilityReducer = createReducer(
  initialAccessibilityStoreState,
  on(AccessibilityActions.toggleHighContrast, (state) => ({
    ...state,
    isHighContrastEnabled: !state.isHighContrastEnabled
  })),
  on(AccessibilityActions.setFontSizePercentage, (state, { fontSizePercentage }) => ({
    ...state,
    fontSizePercentage
  })),
  on(AccessibilityActions.resetReducer, () => initialAccessibilityStoreState)
);
